import React, { useMemo } from "react";
import { Price } from "./styled";
import { CurrencyFormatter } from "@/i18n/currency";
import { Money } from "@/utils/money";
import isempty from "lodash/isEmpty";

const ServicePrice = ({ service }) => {
  const priceWithDiscount = useMemo(() => {
    if (isempty(service.public_discounts)) return null;
    const discount = Math.max(
      ...service.public_discounts.map(({ amount }) => amount)
    );
    if (!discount) return null;
    return Money.subtractPercent(service.price, discount);
  }, [service]);
  return (
    <Price>
      {priceWithDiscount !== null ? (
        <strike>{CurrencyFormatter.format(service.price)}</strike>
      ) : (
        <div>{CurrencyFormatter.format(service.price)}</div>
      )}
      {priceWithDiscount !== null && (
        <div>{CurrencyFormatter.format(priceWithDiscount)}</div>
      )}
    </Price>
  );
};

export default ServicePrice;
